import "./Home.module.css";
import Header from "@/reusable_sections/Header";
import DigitalDominationStartsHere from "./sections/DigitalDominationStartsHere";
import NicheExpertise from "./sections/NicheExpertise";
import TheJargonTranslator from "./sections/TheJargonTranslator";
import StrategicOfferings from "./sections/StrategicOfferings";
import TheImpactReport from "./sections/TheImpactReport";
import LetsFindYourVoice from "./sections/LetsFindYourVoice";
import GlamVaultUniversalFooter from "@/reusable_sections/Footer";
export default function HomePage() {
  return <div>
      <Header />
      <DigitalDominationStartsHere />
      <NicheExpertise />
      <TheJargonTranslator />
      <StrategicOfferings />
      <TheImpactReport />
      <LetsFindYourVoice />
      <GlamVaultUniversalFooter />
    </div>;
}